import type { AdminUser } from '@/types'

type AdminIdentity = Pick<AdminUser, 'id'> & Partial<
  Pick<AdminUser, 'role_id' | 'role_code'>
> & {
  roleId?: string
  roleCode?: string
  role?: string
}

const normalizeRole = (value?: string): string =>
  value?.trim().toLowerCase().replace(/-/g, '_') ?? ''

export const isSuperadminIdentity = (
  user: AdminIdentity | null | undefined
): boolean => {
  if (!user) {
    return false
  }

  return [
    user.role_id,
    user.roleId,
    user.role_code,
    user.roleCode,
    user.role,
  ].some(role => {
    const normalizedRole = normalizeRole(role)
    return normalizedRole === 'arl_superadmin' || normalizedRole === 'superadmin'
  })
}

export const canCreateAdminUser = (
  currentUser: AdminIdentity | null | undefined
): boolean => isSuperadminIdentity(currentUser)

export const canEditAdminUser = (
  currentUser: AdminIdentity | null | undefined,
  targetUser: Pick<AdminUser, 'id'>
): boolean => isSuperadminIdentity(currentUser) && currentUser?.id !== targetUser.id

export const canResetAdminUserPassword = (
  currentUser: AdminIdentity | null | undefined,
  targetUser: Pick<AdminUser, 'id'>
): boolean =>
  isSuperadminIdentity(currentUser)
  && Boolean(currentUser?.id)
  && currentUser?.id !== targetUser.id
